import { gql } from '@apollo/client';

export const deleteUtilizationUnitAssetMutation = gql`
  mutation DeleteEkaUtilizationUnit($utilizationUnitId: ID!) {
    ekaDeleteUtilizationUnit(utilizationUnitId: $utilizationUnitId) {
      __typename
    }
  }
`;
